module.exports = __webpack_public_path__ + "img/5.7458db33.jpg";